import React from "react";

const PhotoIcon = () => {
    return (
        <svg width="64" height="66" viewBox="0 0 64 66" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 43.8444C37.1546 43.8444 41.3333 39.5961 41.3333 34.3555C41.3333 29.115 37.1546 24.8666 32 24.8666C26.8453 24.8666 22.6666 29.115 22.6666 34.3555C22.6666 39.5961 26.8453 43.8444 32 43.8444ZM32 41.4722C35.866 41.4722 39 38.2859 39 34.3555C39 30.4251 35.866 27.2389 32 27.2389C28.134 27.2389 25 30.4251 25 34.3555C25 38.2859 28.134 41.4722 32 41.4722Z"
                fill="white"
                fillOpacity="0.54"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43.2382 15.3777C40.442 12.7646 37.8658 10.6333 31.9172 10.6333C25.9686 10.6333 23.3924 12.7646 20.5962 15.3777H11C7.13398 15.3777 3.99997 18.564 3.99997 22.4944V46.2166C3.99997 50.1471 7.13398 53.3333 11 53.3333H53C56.866 53.3333 60 50.1471 60 46.2166V22.4944C60 18.564 56.866 15.3777 53 15.3777H43.2382ZM42.3256 17.75L42.0807 17.52C41.8478 17.301 41.6222 17.089 41.4075 16.89C40.5299 16.0767 39.7509 15.401 38.9108 14.8395C37.3274 13.7813 35.3455 13.0055 31.9172 13.0055C28.4889 13.0055 26.507 13.7813 24.9236 14.8395C24.0836 15.401 23.3045 16.0767 22.4269 16.89C22.2118 17.0893 21.9872 17.3005 21.7537 17.5199L21.5089 17.75H11C8.42264 17.75 6.3333 19.8741 6.3333 22.4944V46.2166C6.3333 48.8369 8.42264 50.9611 11 50.9611H53C55.5773 50.9611 57.6666 48.8369 57.6666 46.2166V22.4944C57.6666 19.8741 55.5773 17.75 53 17.75H42.3256Z"
                fill="white"
                fillOpacity="0.54"
            />
        </svg>
    );
};

export default PhotoIcon;
